import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { ControlsModule } from "src/app/controls/controls.module";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { SettingsViewComponent } from "./settings-view.component";
import { SettingsListComponent } from "./settings-list/settings-list.component";
import { TablerIconComponent } from "angular-tabler-icons";
import { EditProfileModule } from "./edit-profile/edit-profile.module";

@NgModule({
  declarations: [
    SettingsViewComponent,
    SettingsListComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    ControlsModule,
    SharedModule,
    TablerIconComponent,
    EditProfileModule
  ],
  exports: [
    SettingsViewComponent
  ]
})
export class SettingsViewModule { }